export const DEPOSIT_SHIP_STATUS_OPTION = [
    { key: '已发货', value: '已发货' },
    { key: '未发货', value: '未发货' }
];

export const PAYID_ATATUS = {
    DEPOSIT: "定金已支付",
    ALL: "全额支付"
};